import { Controller } from "@hotwired/stimulus"

// Lleva a la vista el elemento al conectar (feedback 10: la telemetría
// resaltada a la que se llegó por link). Solo scroll: el resaltado es CSS.
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ block: "center" })
  }
}
